import React from "react";
import styles from "./StatusPill.module.css";

// Each entry can define textColor and bgColor independently.
// Omit bgColor for a plain text (no pill background) look.
const defaultStatusConfig = {
  critical: { textColor: "#d93025", bgColor: "#fde8e4" },
  important: { textColor: "#c2185b" },
  unknown: { textColor: "#3c4043", bgColor: "#f1f3f4" },
  enabled: { textColor: "#1e8e4e", bgColor: "#e6f7ed" },
  disabled: { textColor: "#d93025", bgColor: "#fdecea" },
};

const StatusPill = ({
  children,
  statusConfig = defaultStatusConfig,
  fallback = { textColor: "#3c4043", bgColor: "#f1f3f4" },
}) => {
  // console.log(children)
  const text = children?.toString() || "--";
  const config = statusConfig[text.toLowerCase()] || fallback;

  return (
    <span
      className={styles.pill}
      style={{
        color: config.textColor,
        backgroundColor: config.bgColor || "transparent",
        paddingLeft: config.bgColor ? "0.75rem" : 0,
        paddingRight: config.bgColor ? "0.75rem" : 0,
      }}
    >
      {text}
    </span>
  );
};

export default StatusPill;